<span nz-icon>
  <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.25 8.183a4.1 4.1 0 0 0 1.416-3.1 4.167 4.167 0 1 0-8.333 0 4.1 4.1 0 0 0 1.417 3.1A6.667 6.667 0 0 0 .833 14.25a.833.833 0 0 0 1.667 0 5 5 0 0 1 10 0 .833.833 0 0 0 1.666 0 6.666 6.666 0 0 0-3.916-6.067Zm-2.75-.6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm8.116.267A4.167 4.167 0 0 0 12.5.917a.833.833 0 0 0 0 1.666 2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1-1.25 2.159.832.832 0 0 0-.042 1.416l.325.217.108.058a5.833 5.833 0 0 1 3.334 5.317.833.833 0 0 0 1.666 0 7.499 7.499 0 0 0-3.525-6.4Z"
      fill="currentColor"
    />
  </svg>
</span>
